import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from "@mui/material";
import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { dialogButtonConfirm } from "../../../const/DialogData";
import { addPrenotazioni } from "../../../const/urlAction";
import handlerError from "../../../functions/handlerError";
import { closePrenotaNewDialog } from "../../../redux/reducers/prenotazioneNew-reducer";
import { notificationOpen } from "../../../redux/reducers/notification-reducer";
import { loadprenotazioniTableState } from "../../../redux/reducers/prenotazioneTable-reducer";
import { showLoader, hideLoader } from "../../../redux/reducers/appLoader-reducer";
import { saveDataForRiepilogo } from "../../../redux/reducers/RiepilogoDialogAfterPrenotazione-reducer";
import { useTranslation } from "react-i18next";
import MeetingParticipantsSection from "../Common/MeetingParticipantsSection";

const urlBase = process.env.REACT_APP_URL;

export default function DialogConfermaPrenotazioneSuggerimentoNew({ elementsSelected }) {
  const [sendPrenotazione, setSendPrenotazione] = useState(0);
  const [elements, setElements] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const userDate = useSelector((state) => state.userDate);
  const prenotaNewData = useSelector((state) => state.prenotazioneNew);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { selectedDate, selectedStartTime, selectedEndTime } = prenotaNewData;
  const [titoloRiunione, setTitoloRiunione] = useState("");
  const [invioNotifica, setInvioNotifica] = useState(true);
  const [participantsList, setParticipantsList] = useState([]);
  const [partecipanteInput, setPartecipanteInput] = useState("");

  function closeForm() {
    setIsOpen(false);
    setElements(null);
    setTitoloRiunione("");
    setInvioNotifica(true);
    setParticipantsList([]);
    setPartecipanteInput("");
  }

  useEffect(() => {
    if (elementsSelected && elementsSelected.elementoDaMostrare) {
      setElements(elementsSelected.elementoDaMostrare);
      setIsOpen(true);
    }
  }, [elementsSelected]);

  // Aggiunge la prenotazione suggerita
  useEffect(() => {
    let isMounted = true;
    if (sendPrenotazione > 0 && elements) {
      dispatch(showLoader());
      (async () => {
        const { idPostazione } = elements;
        const requestBody = {
          prenotazioni: [{ utente: userDate.idUtente, IdPosto: idPostazione }],
          disabilitazione: false,
          dataPrenotazione: moment(new Date(selectedDate)).format(),
          oraInizioPrenotazione: moment(new Date(selectedStartTime)).format("HH:mm"),
          oraFinePrenotazione: moment(new Date(selectedEndTime)).format("HH:mm"),
          dataFineRipetizioni: moment(new Date(selectedDate)).format(),
          giorniRipetizione: [],
          idPostazione: idPostazione
        };

        // Partecipanti sala riunioni
        if (elements.isSalaRiunione) {
          let finalPartecipanti = [...participantsList];
          if (partecipanteInput.trim() !== "") {
            finalPartecipanti.push(partecipanteInput.trim().toUpperCase());
          }
          if (finalPartecipanti.length > 0) {
              requestBody.partecipantiRiunione = { [idPostazione]: finalPartecipanti };
          }
          if (titoloRiunione.trim() !== "") {
              requestBody.titoloRiunione = { [idPostazione]: titoloRiunione };
          }
          requestBody.invioNotificaInvito = { [idPostazione]: invioNotifica };
        }

        const { action, method } = addPrenotazioni;
        let url = urlBase + action;
        try {
          const response = await axios({
            method: method,
            url,
            data: requestBody,
          });
          if (response.data.ok && isMounted) {
            dispatch(closePrenotaNewDialog());
            dispatch(loadprenotazioniTableState());
            dispatch(hideLoader());
            dispatch(
              notificationOpen({
                message: response.data.message,
                status: "success",
              })
            );
            dispatch(saveDataForRiepilogo(response.data.result));
            closeForm();
          } else {
            dispatch(hideLoader());
            dispatch(
              notificationOpen({
                message: response.data.message,
                status: "error",
              })
            );
          }
        } catch (error) {
          console.error(error);
          dispatch(hideLoader());
          const notificationError = handlerError(error);
          dispatch(notificationOpen(notificationError));
        }
      })();
    }
    return () => {
      isMounted = false;
    };
  }, [sendPrenotazione]);

  return (
    <>
      {elements && (
        <Dialog
          open={isOpen}
          onClose={closeForm}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle id="alert-dialog-title">{t("Confirm_booking")}</DialogTitle>
          <DialogContent className="border-Content-dialog">
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography>
                  {t("msg_2")}{" "}
                  <b>
                    {elements.edificioDenominazione +
                      " - " +
                      elements.zonaDenominazione +
                      " - " +
                      elements.stanzaDenominazione +
                      (elements.isSalaRiunione ? "" : " - " + elements.posto)}
                  </b>
                  ?
                </Typography>
              </Grid>

              {elements.isSalaRiunione && (
                <MeetingParticipantsSection
                  titoloRiunione={titoloRiunione}
                  setTitoloRiunione={setTitoloRiunione}
                  invioNotifica={invioNotifica}
                  setInvioNotifica={setInvioNotifica}
                  participantsList={participantsList}
                  setParticipantsList={setParticipantsList}
                  partecipanteInput={partecipanteInput}
                  setPartecipanteInput={setPartecipanteInput}
                />
              )}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={closeForm}>{t(dialogButtonConfirm.Cancel)}</Button>
            <Button
              variant="contained"
              onClick={() => setSendPrenotazione((old) => old + 1)}
            >
              {t(dialogButtonConfirm.Confirm)}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
